// extracted by mini-css-extract-plugin
module.exports = {"container":"UpgradePlanChipStyle_container__zNPUK","text":"UpgradePlanChipStyle_text__2kGZC"};